import { createSelector } from "reselect";
import { getAllsureHomeClaim } from "./index";

export const getIncidentDetails = createSelector(
    getAllsureHomeClaim,
    (allsureHomeClaim) => allsureHomeClaim.incidentDetails
);
export const getIncidentDetailsForm = createSelector(
    getIncidentDetails,
    (incidentDetails) => incidentDetails.form
);


